import React, { useEffect, useState } from 'react'
import { Box, MenuItem, Popover, Stack } from '@mui/material'
import IcFlagEn from '../../../assets/icons/ic_flag_en.svg'
import IcFlagPtBR from '../../../assets/icons/ic_flag_pt_br.svg'
import { useTranslation } from 'react-i18next'

const LANGUAGES = [
  {
    value: 'pt',
    label: 'Português',
    icon: IcFlagPtBR.toString()
  },
  {
    value: 'en',
    label: 'English',
    icon: IcFlagEn.toString()
  }
]

export default function LanguagePopover () {
  const [open, setOpen] = useState(null)
  const { i18n } = useTranslation()
  const [language, setLanguage] = useState(LANGUAGES[0])

  const handleOpen = (event: any) => {
    setOpen(event.currentTarget)
  }

  const changeLanguage = async (option: any) => {
    setOpen(null)
    setLanguage(option)
    void i18n.changeLanguage(option.value)
  }

  useEffect(() => {
    //setLanguage((i18n.resolvedLanguage === 'pt') ? LANGUAGES[0] : LANGUAGES[1])
    setLanguage(LANGUAGES[0])
  }, [])

  return (
    <>
      {/*
      <IconButton
        onClick={handleOpen}
        sx={{
          padding: 0,
          width: 36,
          height: 36,
          ...(typeof open && {
            bgcolor: (theme) => alpha(theme.palette.primary.main, theme.palette.action.focusOpacity)
          })
        }}
      >
        <img src={language.icon} alt={language.label} style={{ borderRadius: 2 }} />
      </IconButton>
      */}
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            mt: 1.5,
            ml: 0.75,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75
            }
          }
        }}
      >
        <Stack spacing={0.75}>
          {LANGUAGES.map((option) => (
            <MenuItem key={option.value} selected={option.value === language.value} onClick={async () => await changeLanguage(option)}>
              <Box component="img" alt={option.label} src={option.icon} sx={{ width: 28, mr: 2 }} />
              {option.label}
            </MenuItem>
          ))}
        </Stack>
      </Popover>
    </>
  )
}
